/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EpsIcon = createIcon("EpsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.584 30v-1.899l-6.543-.009v-3.726h5.661v-1.854h-5.643v-3.645h6.39l.009-1.881H7.854V30h8.73Zm4.887 0v-4.716h2.682c2.772 0 4.617-1.512 4.617-4.095 0-2.727-2.097-4.203-4.905-4.203h-4.617V30h2.223Zm2.628-6.471h-2.646v-4.815h2.583c1.521 0 2.655.855 2.655 2.349 0 1.467-1.071 2.466-2.592 2.466Zm11.556 6.651c3.114 0 5.085-1.593 5.085-3.636 0-1.377-.45-3.267-3.357-3.861l-2.34-.522c-1.53-.351-1.989-.837-1.989-1.683 0-1.17 1.134-1.872 2.565-1.872 1.44 0 2.592.54 2.754 2.088h2.214c-.027-2.106-1.746-3.87-4.995-3.87-2.781 0-4.86 1.539-4.842 3.897.027 1.899 1.215 3.033 3.159 3.429l2.394.522c1.332.288 2.223.819 2.223 1.89 0 1.206-1.269 1.863-2.88 1.863-1.521 0-2.727-.711-3.015-2.025h-2.268c.297 2.511 2.763 3.78 5.292 3.78Z",
    fill: "#300"
  }));
}, {
  "i18nKey": "svg.EpsIcon"
});